require('es6-promise/auto'); // require Promise polyfill for IE

var util = require('lib/util');

// NodeList.prototype.forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = util.isHTMLNode(argItem);
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

(function () {
    var arr = [window.Element, window.CharacterData, window.DocumentType];
    var args = [];

    arr.forEach(function (item) {
        if (item) {
            args.push(item.prototype);
        }
    });

    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('remove')) {
                return;
            }
            Object.defineProperty(item, 'remove', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function remove() {
                    this.parentNode.removeChild(this);
                }
            });
        });
    })(args);
})();


Element.prototype.remove = (function (remove) {
    return function () {
        if (arguments.length) {
            // polyfill for solo 1.5.0 Element.remove(child, ...)
            // this form of remove method call should not be used anywhere else
            // and must be removed in the future
            Array.prototype.slice.call(arguments).forEach(function (el) {
                this.removeChild(el);
            }, this);
            return;
        }
        remove.call(this);
    }
})(Element.prototype.remove);


/**
 * The global object that is exposed by the Cortona3D Solo library.
 * 
 * @global
 * @implements module:solo
 * @implements external:EventEmitter
 * @tutorial event-handling
 */

var Cortona3DSolo = require('solo');

if (!window.Cortona3DSolo) window.Cortona3DSolo = Cortona3DSolo;

var util = require('lib/util');
var expand = util.expand;
var b64toBlob = require('lib/b64ToBlob');

var usedModules = require('app').usedModules;

console.log('Cortona3D Solo v' + VERSION);

module.exports = expand(Cortona3DSolo, {
    /**
     * _Asynchronous method_. Enables the use of functional modules in API.
     * 
     * @memberof module:solo
     * @async
     * @param {string} moduleName -
     * - `"core"` - the internal module to manage the 3D illustration without usage of the Cortona3D Viewer component. See namespaces {@link module:solo.core core}, {@link module:solo.app app};
     * - `"tag"` - the internal module that implements the Cortona3D Tag API. See namespaces {@link module:solo.core tag}, {@link module:solo.core core}, {@link module:solo.app app};
     * - `"drawing"` - the internal module to manage the 2D illustration. See namespace {@link module:solo.app.drawing app.drawing};
     * - `"touch"` - the internal module to manage pointer events in the 3D window. See namespace {@link module:solo.touch touch};
     * - `"skin"` - the internal module that provides the UI framework. See namespace {@link module:solo.skin skin};
     * - `"require"` - the internal module implements the functionality of the {@link https://github.com/amdjs/amdjs-api/blob/master/AMD.md AMD} module loader similar to {@link http://requirejs.org/ RequireJS}. Adds three global functions:
     *     - `require()`
     *     - `requirejs()`
     *     - `define()`
     * - The name of the external add-on that is used to extend the functionality of the standard API and use the format of the AMD module. It is required to use external or built-in loader of AMD modules.
     * @param {object} [options] - Module options
     * @param {string} options.src - The src property specifies the URL of the external file:
     * - companion file *.interactivity.xml*
     * - VRML file *.wrl*
     * - compressed (zip) package file containing the RapidAuthor publication *.cortona3d* *.vmb* *.zip*
     * - SVG file *.svg* 
     * - image file *.png* *.jpg* *.gif*
     * @param {number} options.features - A features bitmask of the Cortona3D Solo instance. See the {@link module:solo.app app} properties.
     * @param {HTMLElement} options.element 
     * - The `<canvas>` element for the `"core"` or `"tag"` module
     * - The `<svg>` element for the `"drawing"` module
     * @param {string} options.prefixURL -  The URL prefix to loading the Corona3D Solo files.
     * It is preferable to use {@link module:solo.baseUrl solo.baseUrl} property instead of this option.
     * @param {number} options.totalMemory=64 - Total memory used by the Cortona3D Solo core in MB (deprecated since 2.0.0).
     * @param {HexColorString} options.hotspotHoverColor=#FF0000 - The color to the hovered hotspot area on the 2D illustration.
     * @param {HexColorString} options.hotspotSelectionColor=#FF0000 - The color to the selected hotspot area on the 2D illustration.
     * @param {HexColorString} options.ipcHoverColor=#808080 - The color to the hovered 3D object in the interactive parts catalog.
     * @param {HexColorString} options.ipcSelectionColor=#FFD133 - The color to the selected 3D object in the interactive parts catalog.
     * @returns {Promise<object>} `Promise` whose fulfillment handler receives an object with exports and options of the loaded functional module
     * @see external:Promise
     */
    use: function (moduleName, options) {
        if (moduleName === 'Cortona3DSoloSkin') {
            moduleName = 'skin';
        } else if (moduleName === 'Cortona3DSoloTouch') {
            moduleName = 'touch';
        }
        var usedModule = usedModules[moduleName],
            usedAddon = usedModules.addons[moduleName];
        var ERROR_MESSAGE = 'The "core" and "tag" modules cannot be used simultaneously';
        switch (moduleName) {
            case 'core':
                if (!usedModule) {
                    if (usedModules.tag) return Promise.reject(new Error(ERROR_MESSAGE));
                    return new Promise(function (resolve, reject) {
                        usedModules[moduleName] = usedModule = {
                            config: expand({}, options)
                        };
                        Cortona3DSolo.core = require('core.base').configure(options);
                        expand(Cortona3DSolo.app, require('app.base').app);
                        expand(Cortona3DSolo.app, require('app.procedure').app);
                        expand(Cortona3DSolo.app, require('app.ipc').app);
                        expand(Cortona3DSolo.app, require('app.ui').app);
                        expand(Cortona3DSolo.app, require('app.util').app);
                        Cortona3DSolo.once("core.onRuntimeInitialized", function () {
                            resolve(usedModule);
                        });
                        Cortona3DSolo.once("core.onError", reject);
                    });
                }
                break;
            case 'tag':
                if (!usedModule) {
                    if (usedModules.core) return Promise.reject(new Error(ERROR_MESSAGE));
                    usedModules[moduleName] = usedModule = {
                        config: expand({}, options)
                    };
                    usedModules.core = usedModule;
                    var tagPromise = Cortona3DSolo.use('Cortona3DSoloTag');
                    return new Promise(function (resolve, reject) {
                        Cortona3DSolo.core = require('core.base').configure(expand({
                            coreURL: 'Cortona3DSoloCoreTag.js'
                        }, options));
                        expand(Cortona3DSolo.app, require('app.base').app);
                        expand(Cortona3DSolo.app, require('app.ui').app);
                        expand(Cortona3DSolo.app, require('app.util').app);
                        Cortona3DSolo.once("core.onRuntimeInitialized", function () {
                            tagPromise
                                .then(function () {
                                    Cortona3DSolo.core.Stella = Cortona3DSolo.tag;
                                    Cortona3DSolo.on('app.willStartNavigateInScene', function () {
                                        if (Cortona3DSolo.tag.Model3D.instance.tooltipOver3D) {
                                            Cortona3DSolo.tag.Model3D.instance.tooltipOver3D.hide();
                                        }
                                    });
                                    resolve(usedModule);
                                })
                                .catch(reject);
                        });
                        Cortona3DSolo.once("core.onError", reject);
                    });
                }
                break;
            case 'drawing':
                if (!usedModule) {
                    usedModules[moduleName] = usedModule = {
                        config: expand({}, options)
                    };
                    expand(Cortona3DSolo.app, require('app.drawing').configure(options));
                }
                break;
            case 'touch':
                if (!usedModule) {
                    usedModules[moduleName] = usedModule = {
                        config: expand({}, options)
                    };
                    expand(Cortona3DSolo, require('touch').configure(options));
                }
                break;
            case 'skin':
                if (!usedModule) {
                    Cortona3DSolo.use('require');
                    usedModules[moduleName] = usedModule = {
                        config: expand({}, options)
                    };
                    expand(Cortona3DSolo, require('skin').configure(options));
                }
                break;
            case 'require':
                if (!usedModule) {
                    if (util.detectAMDLoader()) {
                        console.log('The AMD loader is already on the page.');
                    } else {
                        expand(window, require('./require-mini'));
                    }
                    usedModules[moduleName] = usedModule = {
                        config: expand({}, options) // require global config
                    };
                    window.require.onError = function () { };
                    window.require.config(usedModule.config);
                    require('./require-plugin-res');
                    require('./require-plugin-file');
                    require('./require-plugin-css');
                    require('./require-plugin-json');
                    require('./require-plugin-xml');
                    require('./require-plugin-raw');
                }
                break;
            default: // addon
                if (usedAddon) {
                    return Promise.resolve(usedAddon);
                } else {
                    return Cortona3DSolo
                        .use('require')
                        .then(function () {
                            // module options
                            var localOptions = expand({}, options),
                                config = usedModules.require && usedModules.require.config || {},
                                prefixURL = localOptions.prefixURL || Cortona3DSolo.baseUrl;

                            usedModules.addons[moduleName] = usedAddon = {
                                config: localOptions
                            };

                            if (!prefixURL) {
                                if (usedModules.core) {
                                    prefixURL = Module.locateFile('');
                                }
                            }

                            config = expand({}, config, {
                                context: 'Cortona3DSolo',
                                baseUrl: prefixURL,
                                config: {}
                            });

                            config.config[moduleName] = localOptions;

                            return Cortona3DSolo.app.util.requirePromise(moduleName, window.requirejs.config(config))
                                .then(function (exports) {
                                    usedAddon.exports = exports;
                                    return usedAddon;
                                });
                        });
                }
        }
        return Promise.resolve(usedModule);
    },
    app: expand(require('app').app, {
        util: {
            /**
             * A helper method.
             * Convert DOM XML tree to JavaScript object:
             * ```xml
             * <node att1="value1" att2="value2">
             *      <foo>Foo</foo>
             *      <bar>
             *          <![CDATA[Bar]]>
             *      </bar>
             *      <items>
             *          <item>i1</item>
             *          <item>i2</item>
             *          <item>i3</item>
             *          <item>i4</item>
             *      </items>
             * </node>
             * ```
             * ```
             * {
             *  node: {
             *      "@name": "node",
             *      "@attributes": {
             *          att1: "value1",
             *          att2: "value2"
             *      },
             *      "@children": [
             *          { "@name": "foo", "#text": "Foo" },
             *          { "@name": "bar", "#text": "Bar" },
             *          { "@name": "items", ... }
             *      ],
             *      foo: { "@name": "foo", "#text": "Foo" },
             *      bar: { "@name": "bar", "#text": "Bar" },
             *      items: {
             *          "@name": "items",
             *          "@children": [ ... ],
             *          item: [
             *              { "@name": "item", "#text": "i1" },
             *              { "@name": "item", "#text": "i2" },
             *              { "@name": "item", "#text": "i3" },
             *              { "@name": "item", "#text": "i4" }
             *          ]
             *      }
             *  }
             * }
             * ```
             * @memberof module:solo.app.util
             * @method
             * @param {Document} xml The XML document
             * @returns {XMLNodeData} The JavaScript object
             */
            xmlToJSON: require('xml2json.js'),
            /**
             * Loads a resource file from URL using XMLHttpRequest
             * 
             * @async
             * @memberof module:solo.app.util
             * @method
             * @param {string} url An URL to load the resource
             * @param {string} [overrideMimeType]
             * @param {string} [responseType]
             * @returns {Promise<XMLHttpRequest>} `Promise` whose fulfillment handler receives an XMLHttpRequest object when the requested resource has successfully been loaded.
             * @see {@link https://developer.mozilla.org/ru/docs/Web/API/XMLHttpRequest XMLHttpRequest}
             * @see external:Promise
             * @fires "app.onProgress"
             * @since 1.4.3
             */
            loadResource: util.loadResource,
            /**
             * Converts the path specified by the first argument to the absolute path relative to the base path specified by the second argument.
             * If the second argument is omitted, the absolute path is generated relative to the URL of the loaded HTML document.
             * 
             * @memberof module:solo.app.util
             * @method
             * @param {string} resourceUrl
             * @param {string} [baseUrl]
             * @return {string} 
             * @since 1.4.3
             */
            toUrl: function (resourceUrl, baseUrl) {
                var url = (typeof resourceUrl !== 'string') ? '' : resourceUrl;
                if (url.match(/^[a-z]+\:\/\//i)) {
                    return url; // absolute url
                } else if (url.match(/^\/\//)) {
                    return 'http:' + url; // absolute url
                } else if (url.match(/^[a-z]+\:/i)) {
                    return url; // data URI
                }

                var a = document.createElement('a');
                if (url[0] === '/') {
                    a.href = util.getBaseURL(baseUrl);
                    a.href = a.protocol + '//' + a.host + url;
                } else {
                    a.href = util.getBaseURL(baseUrl) + url;
                }
                url = a.href;
                return url.replace(/(\/\.\/|\/[^/]+\/\.\.\/)/g, '/').replace(/([^:/])\/{2,}/g, '$1/');
            },
            /**
             * Converts base64-encoded data to a Blob object.
             * 
             * @async
             * @memberof module:solo.app.util
             * @method
             * @param {string|CharacterData|Array} b64Data A Base64-encoded string, character data, a data URL, or an array of data objects of the following types.
             * @param {string} [contentType] The content type to assign to the new Blob
             * @param {number} [sliceSize=4194304]
             * @returns {Promise<Blob>} `Promise` whose fulfillment handler receives a Blob object when base64-encoded data has successfully been decoded
             * @see external:Blob
             * @see external:Promise
             * @since 1.5.6
             */
            b64toBlob: b64toBlob,

            /** 
             * The method defines a new class that can be inherited from parent class.
             *
             * @memberof module:solo.app.util
             * @method
             * @param parent {?Function} The parent class of the new class or null
             * @param ctor {Function} The constructor of the new class
             * @param methods {Object} An object literal containing the methods of the new class
             * @return {Function} The constructor function of the new class
             * @since 1.6.0
             */
            defineClass: util.defineClass,

            /**
             * Wrap `requirejs()` call with Promise.
             * 
             * @async
             * @memberof module:solo.app.util
             * @method
             * @param {string} name The name of module to load
             * @param {function} [requirejs=window.requirejs] An `requirejs` function
             * @returns {Promise<exports>} `Promise` whose fulfillment handler receives the export object of a successfully loaded AMD module
             * @see external:Promise
             * @since 1.6.0
             */
            requirePromise: function (name, req) {
                return new Promise(function (resolve, reject) {
                    req = req || window.requirejs;
                    Promise.all([req([name], resolve, reject)]).catch(function () { });
                });
            }
        },
        ui: {
            /** 
             * Creates HTML element with given tag name, list of attributes and array of children.
             *
             * @memberof module:solo.app.ui
             * @method
             * @param {CSSSelector} name The name of the new element. Class and ID selectors can be used. If the element type name is omitted, `<div>` is created by default. 
             * @param {object} [options] The properties of the new element. 
             * @param {...*} [content] The contents of the new element. It can be plain text, HTMLElement or an array.
             * @return {HTMLElement}
             * @since 1.6.0
             * @example
var h = Cortona3DSolo.app.ui.createElement;

h('img#img-001.graphic', { src: 'image.png' }); 
// -> <img id="img-001" class="graphic" src="image.png"/>

h('span#msg', 'A text'); 
// -> <span id="msg">A text</span>

h('#id-001', h('ul', [h('li', 'a'), h('li', 'b')]); 
// -> <div id="id-001"><ul><li>a</li><li>b</li></ul></div>
             */
            createElement: require('lib/create-element').createElement,
            /** 
             * Create HTML elements from string.
             *
             * @memberof module:solo.app.ui
             * @method
             * @param {string} syntax HTML string
             * @return {HTMLElement[]}
             * @since 1.6.0
             * @example
Cortona3DSolo.app.ui.html('<img src="image.png"/><span>A text</span>');
// -> [ <img src="image.png"/>, <span>A text</span> ]
             */
            html: require('lib/create-element').createElementsFromHTML,
            /**
             * Returns a new instance of CSSObject.
             *  
             * @memberof module:solo.app.ui
             * @method
             * @param {object} [rules]
             * @return {CSSObject}
             * @since 1.6.0
             * @example
Cortona3DSolo.app.ui.css({ body: { backgroundColor: 'red' }});
// -> body { background-color: red; }
            */
            css: require('lib/css-object'),
            /** 
             * Returns new instance of ColorObject.
             * 
             * @memberof module:solo.app.ui
             * @method
             * @param {string|object|number} [color] 
             * - HTML hex string
             * - RGB object
             * - HSL object
             * - an 32-bit integer specifies RGB color in the following hexadecimal form `0x00RRGGBB`.
             * @return {ColorObject}
             * @since 1.6.0
             * @example
var color = Cortona3DSolo.app.ui.color;
color('#FF8800');
color('#F80');
color({r: 255, g: 136, b: 0});
color({h: 32, s: 100, l: 50});
color(0xFF8800);
             */
            color: require('lib/color-object')
        }
    }),
    /**
     * A helper method.
     * Recursively combines the properties of objects. If a property with the name already exists, it will be overwritten.
     * @memberof module:solo
     * @method
     * @param {object} obj Destination object
     * @param {...object} [src] Source objects
     * @returns {object} Destination object
     */
    expand: expand,
    /**
     * Dispatches the event by emit the event object into event flow from the main object {@link Cortona3DSolo} or by calling appropriate hook method.
     * @memberof module:solo
     * @param {string} eventName Event name
     * @param {...any} [arg] Arguments of the event
     * @since 1.4.0
     */
    dispatch: function (eventName, arg) {
        if (!PRODUCTION || Cortona3DSolo.__trace === true) {
            if (eventName.indexOf("AnimationFrame") === -1) {
                console.log("EVENT(" + eventName + "): ", Array.prototype.slice.call(arguments, 1));
            }
        }
        Cortona3DSolo.emit.apply(Cortona3DSolo, arguments);
        var ns = eventName.split('.');
        var method = ns.pop();
        var context = Cortona3DSolo;
        while (ns.length && context) {
            context = context[ns.shift()];
        }
        if (context && typeof context[method] == 'function') {
            switch (arguments.length) {
                case 1:
                    context[method].call(Cortona3DSolo);
                    break;
                case 2:
                    context[method].call(Cortona3DSolo, arguments[1]);
                    break;
                case 3:
                    context[method].call(Cortona3DSolo, arguments[1], arguments[2]);
                    break;
                case 4:
                    context[method].call(Cortona3DSolo, arguments[1], arguments[2], arguments[3]);
                    break;
                case 5:
                    context[method].call(Cortona3DSolo, arguments[1], arguments[2], arguments[3], arguments[4]);
                    break;
                default:
                    // slow method
                    context[method].apply(Cortona3DSolo, Array.prototype.slice.call(arguments, 1));
            }
        }
    }
});

/**
 * Gets a semantic version string of the library.
 * 
 * @static
 * @member {SemVer} version
 * @memberof module:solo
 * @readonly
 * @since 1.5.0
 * @see http://semver.org/
 */

Object.defineProperty(Cortona3DSolo, 'version', {
    get: function () {
        return VERSION;
    },
    enumerable: true
});

/**
 * The EventEmitter class in the event standard module Node.js.
 * @external EventEmitter
 * @see https://nodejs.org/api/events.html#events_class_eventemitter
 */

/**
 * The Promise object represents the eventual completion (or failure) of an asynchronous operation, and its resulting value.
 * @external Promise
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise
 */

/**
 * The HTMLTableRowElement interface provides special properties and methods for manipulating the layout and presentation of rows in an HTML table.
 * @external HTMLTableRowElement
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableRowElement
 */

/**
 * The HTMLTableElement interface provides special properties and methods for manipulating the layout and presentation of tables in an HTML document.
 * @external HTMLTableElement
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableElement
 */

/**
 * The HTMLImageElement interface provides special properties and methods  for manipulating the layout and presentation of <img> elements.
 * @external HTMLImageElement 
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement 
 */

/**
 * The HTMLCanvasElement interface provides properties and methods for manipulating the layout and presentation of canvas elements.
 * @external HTMLCanvasElement 
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement 
 */

/**
 * The URL interface represents an object providing static methods used for creating object URLs.
 * @external URL 
 * @see https://developer.mozilla.org/en-US/docs/Web/API/URL
 */

/**
 * Module is a global JavaScript object with attributes that Emscripten-generated code calls at various points in its execution.
 * @external Module
 * @see http://kripken.github.io/emscripten-site/docs/api_reference/module.html#module-object
 */

/**
 * A Blob object represents a file-like object of immutable, raw data.
 * @external Blob 
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Blob
 */